import { MakeMemberOptional } from '@mm/utils';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import { useCallback, useMemo } from 'react';
import { emojis } from '@mm/constants/emojis/emojis';

export const useStoryReactionsKeywordAlreadyExists = (
  promoters: PromoterModel[],
  type: 'mentions' | 'ig_live',
  promoter?: MakeMemberOptional<PromoterModel, 'id' | 'pageId'>,
) => {
  const storyMentions = promoters.filter(
    cs =>
      cs.kind === 'instagram_story_mention' ||
      cs.kind === 'instagram_story_reaction',
  );

  const igLive = promoters.filter(
    cs => cs.kind === 'instagram_live_comment_guard',
  );

  const promotersByType = type === 'ig_live' ? igLive : storyMentions;

  const keywordAlreadyExists = useCallback(
    (keywordToAdd: string) => {
      return !!promotersByType.find(promoter =>
        promoter.keywords?.find(
          keyword => keyword.toUpperCase() === keywordToAdd.toUpperCase(),
        ),
      );
    },
    [storyMentions, igLive],
  );

  const existsEmoji = useMemo(() => {
    return promotersByType.reduce((acc, prom) => {
      if (prom.id !== promoter?.id) {
        const localEmojis =
          prom.keywords?.filter(keyword => !!emojis[keyword]) ?? [];
        return [...acc, ...localEmojis];
      }
      return acc;
    }, []);
  }, [storyMentions, igLive]);

  const getKeywordsForPromoter = (
    promoter: MakeMemberOptional<PromoterModel, 'id' | 'pageId'>,
  ) => {
    return promoter?.keywords?.filter(keyword => !emojis[keyword]) ?? [];
  };

  const getEmojisForPromoter = (
    promoter: MakeMemberOptional<PromoterModel, 'id' | 'pageId'>,
  ) => {
    return promoter?.keywords?.filter(keyword => emojis[keyword]) ?? [];
  };

  return {
    keywordAlreadyExists,
    existsEmoji,
    getKeywordsForPromoter,
    getEmojisForPromoter,
  };
};
